module.exports = __webpack_public_path__ + "img/biz_logo_ES.66471c9e.png";